if (!customElements.get('product-faq-accordion')) {
  class ProductFaqAccordion extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') {
        return;
      }

      this.dataset.initialized = 'true';
      this.handleClick = this.handleClick.bind(this);
      this.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      delete this.dataset.initialized;
    }

    get duration() {
      const duration = Number.parseInt(this.dataset.duration, 10);

      return Number.isFinite(duration) ? duration : 550;
    }

    get reduceMotion() {
      return window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;
    }

    async handleClick(event) {
      const summary = event.target.closest('summary');

      if (!summary || !this.contains(summary)) {
        return;
      }

      const details = summary.closest('details.details');

      if (!details || !this.contains(details)) {
        return;
      }

      event.preventDefault();

      if (details.dataset.animating === 'true') {
        return;
      }

      if (details.open) {
        await this.closeItem(details);
        return;
      }

      const openedItems = Array.from(
        this.querySelectorAll('details.details[open]')
      ).filter((item) => item !== details);

      await Promise.all([
        ...openedItems.map((item) => this.closeItem(item)),
        this.openItem(details)
      ]);
    }

    async openItem(details) {
      if (this.reduceMotion || this.duration === 0) {
        this.closeOtherItems(details);
        details.open = true;
        return;
      }

      const summary = details.querySelector(':scope > summary');

      if (!summary) {
        details.open = true;
        return;
      }

      details.dataset.animating = 'true';
      details.open = true;
      details.style.overflow = 'hidden';

      const startHeight = summary.offsetHeight;
      const endHeight = details.scrollHeight;

      const animation = details.animate(
        [
          {
            height: `${startHeight}px`
          },
          {
            height: `${endHeight}px`
          }
        ],
        {
          duration: this.duration,
          easing: 'cubic-bezier(0.22, 1, 0.36, 1)'
        }
      );

      try {
        await animation.finished;
      } catch (error) {
        // Une animation annulée ne bloque pas l’accordéon.
      }

      details.style.removeProperty('height');
      details.style.removeProperty('overflow');
      delete details.dataset.animating;
    }

async closeItem(details) {
  if (!details.open) {
    return;
  }

  const summary = details.querySelector(':scope > summary');
  const content = details.querySelector(':scope > .details-content');

  if (this.reduceMotion || this.duration === 0) {
    details.open = false;
    return;
  }

  if (!summary) {
    details.open = false;
    return;
  }

  details.dataset.animating = 'true';
  details.style.overflow = 'hidden';

  const startHeight = details.offsetHeight;
  const endHeight = summary.offsetHeight;

  /*
   * La hauteur conserve la durée choisie dans l’éditeur.
   */
  const heightAnimation = details.animate(
    [
      {
        height: `${startHeight}px`
      },
      {
        height: `${endHeight}px`
      }
    ],
    {
      duration: this.duration,
      easing: 'cubic-bezier(0.22, 1, 0.36, 1)'
    }
  );

  /*
   * Le contenu disparaît beaucoup plus rapidement
   * que la fermeture générale.
   */
  let contentAnimation = null;

  if (content) {
    contentAnimation = content.animate(
      [
        {
          opacity: 1
        },
        {
          opacity: 0
        }
      ],
      {
        duration: 160,
        easing: 'ease-out',
        fill: 'forwards'
      }
    );
  }

  try {
    await heightAnimation.finished;
  } catch (error) {
    // Une animation annulée ne bloque pas l’accordéon.
  }

  details.open = false;

  /*
   * Retire les styles d’animation afin que la réponse
   * soit de nouveau visible à la prochaine ouverture.
   */
  if (contentAnimation) {
    contentAnimation.cancel();
  }

  details.style.removeProperty('height');
  details.style.removeProperty('overflow');
  delete details.dataset.animating;
}

    closeOtherItems(currentDetails) {
      this.querySelectorAll('details.details[open]').forEach((details) => {
        if (details !== currentDetails) {
          details.open = false;
        }
      });
    }
  }

  customElements.define(
    'product-faq-accordion',
    ProductFaqAccordion
  );
}